<template>
  <div>
    <div class="col-lg-8 pl-5 pr-5">
      <cool-select class="custom-input" :placeholder="$t('message.Search recipes')" :items="[]" v-model="selectedRecipe" @search="searchRecipe" @keyup="coolSelectOnKeyUp" :resetSearchOnBlur="false" ref="recipeSearch">
        <template #no-data>
          {{ "" }}
        </template>
      </cool-select>
    </div>
    <div class="col-12 h-100 pt-2">
      <div class="recipes-list" v-if="recipes && recipes.length > 0">
        <div class="row recipe-item align-items-center" v-for="recipe in recipes" :key="recipe._id" @click="viewRecipe(recipe)">
          <div class="col-4 ">
            <dynamic-image-background class="recipe-image" :file-id="recipe.image">
            </dynamic-image-background>
          </div>
          <div class="col-8">
            <h6 class="recipe-title">{{ recipe.name }}</h6>
          </div>
        </div>
        <infinite-loading spinner="waveDots" @infinite="getRecipes" forceUseInfiniteWrapper="window">
          <span slot="no-more">No more recipes</span>
          <span slot="no-results"></span>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      recipes: [],
      recipesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      selectedRecipe: null,
    };
  },

  computed: {
    recipeType() {
      return this.$route.params.recipeType;
    },
  },

  async mounted() {
    await this.getRecipes();

    if (this.recipeType == "breakfast") {
      this.changeAppHeaderText("Breakfast Recipes");
    }
    if (this.recipeType == "lunch") {
      this.changeAppHeaderText("Lunch Recipes");
    }
    if (this.recipeType == "dinner") {
      this.changeAppHeaderText("Dinner Recipes");
    }
  },

  methods: {
    async getRecipes($state) {
      try {
        if (!$state) {
          this.recipes = [];
          this.recipesPagination = {
            pageNumber: 1,
            totalPages: 0,
          };
        }
        let response;

        if (this.recipeType == "breakfast") {
          response = await this.$store.dispatch("getBreakfastRecipes", {
            pageNumber: this.recipesPagination.pageNumber,
            pageSize: 6,
          });
        }
        if (this.recipeType == "lunch") {
          response = await this.$store.dispatch("getLunchRecipes", {
            pageNumber: this.recipesPagination.pageNumber,
            pageSize: 6,
          });
        }
        if (this.recipeType == "dinner") {
          response = await this.$store.dispatch("getDinnerRecipes", {
            pageNumber: this.recipesPagination.pageNumber,
            pageSize: 6,
          });
        }

        if (response.data && response.data.length) {
          this.recipesPagination.totalPages = response.totalPages;
          this.recipesPagination.pageNumber += 1;
          if ($state) {
            this.recipes.push(...response.data);
            $state && $state.loaded();
          } else {
            this.recipes = response.data;
          }
        } else {
          $state && $state.complete();
        }
      } catch (e) { }
    },

    async searchRecipe(searchString) {
      try {
        this.recipeSearchQuery = searchString;
        if (searchString.length > 2) {
          this.recipes = await this.$store.dispatch("filterRecipes", {
            name: searchString,
            type: this.recipeType,
          });
        } else {
          await this.getRecipes();
        }
      } catch (e) { }
    },

    viewRecipe(recipe) {
      this.$store.commit("setState", {
        stateName: "recipe",
        stateValue: recipe,
      });
      this.$router.push({ path: "/recipe" });
    },

    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.recipeSearch.$el.querySelector("input").blur();
      }
    },
  },
};
</script>

<style scoped>
.recipe-image {
  height: 5rem;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
}

.recipes-list {
  padding: 0 1em;
}

.recipe-item {
  padding: 0.5em 0;
  margin-top: 00.2em;
  border-bottom: 0.2px grey solid;
  align-content: center;
}

.recipe-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
</style>
